// removed by extract-text-webpack-plugin
module.exports = {"root":"App__root__1cMN","spinner":"App__spinner__2ILo","dots":"App__dots__kyaO","spinner-rotate":"App__spinner-rotate__3SA5","spinner-bounce":"App__spinner-bounce__357o"};